import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { PapiUser } from '@wix/da-papi-types';
import FavStarFillIcon from '@wix/da-ds/pkg/Icons/16x16/FavStarFill';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import TextTooltipOnHover from '../../../../Popover/Preset/TextTooltipOnHover';

import s from './FavouritesLabel.scss';

export interface Props {
  className?: string;
  tooltipUser?: PapiUser;
}

const FavouritesLabel: React.FC<Props> = ({ className, tooltipUser }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const tooltipText =
    tooltipUser &&
    t('widgets.exhibitionist.favouritesTooltip', {
      username: tooltipUser.username,
    });

  const label = (
    <>
      <FavStarFillIcon className={s['icon']} disableDefaultColors={true} size={IconSize.TINY} />{' '}
      {t('widgets.exhibitionist.favourites')}
    </>
  );

  return (
    <div className={classnames(s['root'], className)}>
      {!isMobile && tooltipText ? (
        <TextTooltipOnHover tooltipText={tooltipText}>{label}</TextTooltipOnHover>
      ) : (
        label
      )}
    </div>
  );
};
FavouritesLabel.displayName = 'FavouritesLabel';

export default FavouritesLabel;
